import { startCase } from 'lodash-es'
import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import ArrowDropDown from '@mui/icons-material/ArrowDropDown'

import {
  cbvThemeNames,
  CBVThemes,
  getGradientSamplesFromHexCodes,
  getHexCodesFromCBVTheme
} from 'features/DataManagement/Components/ColorByValue/utils/cbvThemes'
import CBVThemeIcon from 'features/DataManagement/Components/ColorByValue/CBVThemeIcon'
import { IColorByValueCustomizeColorModalInnerContent } from './types'

const PaletteIcon = ({ className }: { className?: string }) => {
  return <ArrowDropDown className={className} style={{ color: 'inherit' }} />
}

/**
 * Note that preview section can display color not part of
 * the selected palette as it pulls from attribute segment
 * config.
 */
const PaletteSelectPreview = ({
  attributeMap,
  setAttributeMap
}: IColorByValueCustomizeColorModalInnerContent) => {
  const onThemeChange = (evt: SelectChangeEvent<CBVThemes>) => {
    if (attributeMap == null) {
      return
    }

    const selectedTheme = evt.target.value as CBVThemes

    if (selectedTheme !== attributeMap.iconTheme) {
      // Recolor using the new theme selected w/o resetting range
      const colorRange = attributeMap.configurations.length

      const colorArray = getGradientSamplesFromHexCodes(
        getHexCodesFromCBVTheme(selectedTheme),
        colorRange
      )

      setAttributeMap({
        ...attributeMap,
        iconTheme: selectedTheme,
        configurations: attributeMap.configurations.map((config, idx) => ({
          ...config,
          color: colorArray[idx]
        }))
      })
    }
  }

  return (
    <>
      <div className='mb-6 font-semibold leading-none'>Palette</div>
      <div className='flex'>
        <div className='mr-2'>
          <div
            className={[
              'mb-2 mr-4 font-medium uppercase',
              'leading-none tracking-[0.03em] text-gray-500'
            ].join(' ')}
          >
            Selection
          </div>
          <Select
            data-testid='cbv-modal-color-select'
            sx={{ width: '90px' }}
            classes={{
              select: '!flex items-center'
            }}
            size='small'
            IconComponent={PaletteIcon}
            renderValue={(selectedTheme) => (
              <CBVThemeIcon themeName={selectedTheme} />
            )}
            value={attributeMap.iconTheme}
            onChange={onThemeChange}
          >
            {cbvThemeNames
              .filter((themeName) => themeName !== 'custom')
              .map((themeName) => (
                <MenuItem key={themeName} value={themeName}>
                  <CBVThemeIcon themeName={themeName} />
                  <div className='ml-2 font-medium'>{startCase(themeName)}</div>
                </MenuItem>
              ))}
          </Select>
        </div>
        <div className='flex flex-1 flex-col'>
          <div
            className={[
              'mb-2 font-medium uppercase',
              'leading-none tracking-[0.03em] text-gray-500'
            ].join(' ')}
          >
            Preview
          </div>
          <div className='flex flex-1 border border-gray-300 p-2'>
            {attributeMap.configurations.map((config, idx) => (
              <div
                key={`${config.color}-${idx}`}
                className='flex-1'
                style={{ backgroundColor: config.color }}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default PaletteSelectPreview
